import styled from 'styled-components';
import ReactQuill from 'react-quill';

export const StyledReactQuill = styled(ReactQuill)<{ theme: any }>`
    .ql-editor p,
    .ql-editor h1,
    .ql-editor h2,
    .ql-editor h3,
    .ql-editor ol,
    .ql-editor ul,
    .ql-editor pre,
    .ql-editor blockquote {
        color: ${({ theme }) => theme.textColor};
    }
    .ql-snow .ql-picker.ql-header {
        border: 1px solid ${({ theme }) => theme.borderColor};
    }
    .ql-toolbar.ql-snow .ql-picker-label {
        color: ${({ theme }) => theme.textColor};
    }
    .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
        background: ${({ theme }) => theme.toolbarBackground};
        border: 1px solid ${({ theme }) => theme.borderColor};
    }
    .ql-snow .ql-picker-options .ql-picker-item {
        color: ${({ theme }) => theme.color};
    }

    .ql-picker.ql-expanded {
        background: ${({ theme }) => theme.toolbarBackground};
        color: ${({ theme }) => theme.textColor};
    }
    .ql-toolbar.ql-snow {
        // background: ${({ theme }) => theme.toolbarBackground};
    }
`;
